export default __webpack_public_path__ + "static/media/album_1@2x.631dfcbd.png";